// import css from "./blog.module.css";
// import YouTube from "react-youtube";
// import { useMemo, useState } from "react";
// import { Link } from "react-router-dom";

// export default function BlogView({ blogData, windowDimensions }) {
//   const [showCount, setShowCount] = useState(6);

//   const getArticleDateValue = (article) => {
//     const date =
//       article.timestamp ||
//       article.createdAt ||
//       article.createdDate ||
//       article.date ||
//       article.updatedAt;

//     if (!date) return 0;

//     if (date?.toDate) {
//       return date.toDate().getTime();
//     }

//     return new Date(date).getTime() || 0;
//   };

//   const sortedBlogData = useMemo(() => {
//     if (!Array.isArray(blogData)) return [];

//     return [...blogData].sort(
//       (a, b) => getArticleDateValue(b) - getArticleDateValue(a),
//     );
//   }, [blogData]);

//   const handleShowMore = () => {
//     setShowCount((prevCount) => prevCount + 6);
//   };

//   return (
//     <div className={css.bigVideoWrap}>
//       {sortedBlogData.length > 0 && (
//         <div className={css.bigVideoWrapSmall}>
//           <div className={css.bigWrap}>
//             {windowDimensions && (
//               <img
//                 className={css.bigImgBlog}
//                 src={sortedBlogData[0].photo}
//                 alt={sortedBlogData[0].zag}
//               />
//             )}

//             {!windowDimensions && (
//               <img
//                 className={css.bigImgBlog}
//                 src={sortedBlogData[0].photo}
//                 alt={sortedBlogData[0].zag}
//               />
//             )}

//             <div className={css.someTextWrap}>
//               {sortedBlogData[0].check && sortedBlogData[0].linkto ? (
//                 <a
//                   href={sortedBlogData[0].linkto}
//                   target="_blank"
//                   rel="noopener noreferrer"
//                   className={css.videoViewvH1}
//                 >
//                   {sortedBlogData[0].zag}
//                 </a>
//               ) : (
//                 <Link
//                   to={`/blog/${sortedBlogData[0].uid}`}
//                   className={css.videoViewvH1}
//                 >
//                   {sortedBlogData[0].zag}
//                 </Link>
//               )}

//               <p className={css.bigVideoP}>{sortedBlogData[0].chortDesc}</p>
//             </div>
//           </div>

//           <div className={css.smallVideoWrap}>
//             <div className={css.smallvidelListWrap}>
//               {sortedBlogData.map((el, index) => {
//                 if (index < showCount) {
//                   return (
//                     <div
//                       key={el.uid || el.id || index}
//                       className={css.smalVideoPro}
//                     >
//                       {windowDimensions && (
//                         <div className={css.imgWrapBorder}>
//                           {el.check && el.linkto ? (
//                             <a
//                               href={el.linkto}
//                               target="_blank"
//                               rel="noopener noreferrer"
//                             >
//                               <img
//                                 src={el.photo}
//                                 className={css.smallImgBlog}
//                                 alt={el.zag}
//                               />
//                             </a>
//                           ) : (
//                             <Link to={`/blog/${el.uid}`}>
//                               <img
//                                 src={el.photo}
//                                 className={css.smallImgBlog}
//                                 alt={el.zag}
//                               />
//                             </Link>
//                           )}
//                         </div>
//                       )}

//                       {!windowDimensions && (
//                         <div className={css.imgWrapBorder}>
//                           {el.check && el.linkto ? (
//                             <a
//                               href={el.linkto}
//                               target="_blank"
//                               rel="noopener noreferrer"
//                             >
//                               <img
//                                 src={el.photo}
//                                 className={css.smallImgBlog}
//                                 alt={el.zag}
//                               />
//                             </a>
//                           ) : (
//                             <Link to={`/blog/${el.uid}`}>
//                               <img
//                                 src={el.photo}
//                                 className={css.smallImgBlog}
//                                 alt={el.zag}
//                               />
//                             </Link>
//                           )}
//                         </div>
//                       )}

//                       {el.check && el.linkto ? (
//                         <a
//                           href={el.linkto}
//                           target="_blank"
//                           rel="noopener noreferrer"
//                           className={css.videoName}
//                         >
//                           {el.zag}
//                         </a>
//                       ) : (
//                         <Link to={`/blog/${el.uid}`} className={css.videoName}>
//                           {el.zag}
//                         </Link>
//                       )}

//                       <p className={css.videoNameDesc}>{el.chortDesc}</p>
//                     </div>
//                   );
//                 }

//                 return null;
//               })}
//             </div>
//           </div>

//           {showCount < sortedBlogData.length && (
//             <button className={css.mareVideo} onClick={handleShowMore}>
//               Більше статей
//             </button>
//           )}
//         </div>
//       )}
//     </div>
//   );
// }
import css from "./blog.module.css";
import { useEffect, useLayoutEffect, useMemo } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";

const ARTICLES_PER_PAGE = 6;
const BLOG_SCROLL_KEY = "blog-scroll-position";

export default function BlogView({ blogData }) {
  const { page } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  console.log("blogData", blogData);

  const getArticleDateValue = (article) => {
    const date =
      article?.timestamp ||
      article?.createdAt ||
      article?.createdDate ||
      article?.date ||
      article?.updatedAt;

    if (!date) {
      return 0;
    }

    if (typeof date?.toDate === "function") {
      return date.toDate().getTime();
    }

    const parsedDate = new Date(date).getTime();

    return Number.isNaN(parsedDate) ? 0 : parsedDate;
  };

  const sortedBlogData = useMemo(() => {
    if (!Array.isArray(blogData)) {
      return [];
    }

    return [...blogData].sort((a, b) => {
      return getArticleDateValue(b) - getArticleDateValue(a);
    });
  }, [blogData]);

  /*
   * Найновіша стаття відображається
   * окремо у великому блоці.
   */
  const featuredArticle = sortedBlogData.length > 0 ? sortedBlogData[0] : null;

  /*
   * Прибираємо велику статтю зі списку,
   * щоб вона не дублювалася.
   */
  const regularArticles = useMemo(() => {
    return sortedBlogData;
  }, [sortedBlogData]);

  /*
   * /blog = сторінка 1
   * /blog/page/2 = сторінка 2
   */
  const pageFromUrl = page === undefined ? 1 : Number(page);

  const isValidPage = Number.isInteger(pageFromUrl) && pageFromUrl >= 1;

  const requestedPage = isValidPage ? pageFromUrl : 1;

  const totalPages = Math.max(
    1,
    Math.ceil(regularArticles.length / ARTICLES_PER_PAGE),
  );

  const currentPage = Math.min(requestedPage, totalPages);

  /*
   * Накопичувальна пагінація:
   *
   * /blog — 6 статей;
   * /blog/page/2 — 12 статей;
   * /blog/page/3 — 18 статей.
   */
  const visibleArticles = useMemo(() => {
    const visibleCount = currentPage * ARTICLES_PER_PAGE;

    return regularArticles.slice(0, visibleCount);
  }, [regularArticles, currentPage]);

  const hasMoreArticles = visibleArticles.length < regularArticles.length;

  /*
   * Вимикаємо стандартне автоматичне
   * відновлення прокрутки браузером,
   * поки відкритий блог.
   */
  useEffect(() => {
    if (!("scrollRestoration" in window.history)) {
      return undefined;
    }

    const previousValue = window.history.scrollRestoration;

    window.history.scrollRestoration = "manual";

    return () => {
      window.history.scrollRestoration = previousValue;
    };
  }, []);

  /*
   * Нормалізація неправильних URL:
   *
   * /blog/page/1 -> /blog
   * /blog/page/test -> /blog
   * /blog/page/999 -> остання сторінка
   */
  useEffect(() => {
    if (!sortedBlogData.length) {
      return;
    }

    if (!isValidPage) {
      navigate("/blog", {
        replace: true,
        preventScrollReset: true,
      });

      return;
    }

    if (page !== undefined && pageFromUrl === 1) {
      navigate("/blog", {
        replace: true,
        preventScrollReset: true,
      });

      return;
    }

    if (pageFromUrl > totalPages) {
      const lastPageUrl =
        totalPages === 1 ? "/blog" : `/blog/page/${totalPages}`;

      navigate(lastPageUrl, {
        replace: true,
        preventScrollReset: true,
      });
    }
  }, [
    page,
    pageFromUrl,
    isValidPage,
    totalPages,
    sortedBlogData.length,
    navigate,
  ]);

  /*
   * Після зміни URL відновлюємо позицію.
   *
   * Подвійний requestAnimationFrame і setTimeout
   * дають React час додати нові статті в DOM.
   */
  useLayoutEffect(() => {
    const shouldPreserveScroll = location.state?.preserveBlogScroll === true;

    if (!shouldPreserveScroll) {
      return undefined;
    }

    const stateScrollY = Number(location.state?.scrollY);

    const storageScrollY = Number(sessionStorage.getItem(BLOG_SCROLL_KEY));

    const savedScrollY = Number.isFinite(stateScrollY)
      ? stateScrollY
      : storageScrollY;

    if (!Number.isFinite(savedScrollY)) {
      return undefined;
    }

    const restoreScroll = () => {
      window.scrollTo({
        top: savedScrollY,
        left: 0,
        behavior: "auto",
      });
    };

    /*
     * Перша спроба — ще до перемальовування екрана.
     */
    restoreScroll();

    let secondFrameId;
    let timeoutId;
    let finalTimeoutId;

    const firstFrameId = window.requestAnimationFrame(() => {
      restoreScroll();

      secondFrameId = window.requestAnimationFrame(() => {
        restoreScroll();

        timeoutId = window.setTimeout(() => {
          restoreScroll();

          finalTimeoutId = window.setTimeout(() => {
            restoreScroll();

            sessionStorage.removeItem(BLOG_SCROLL_KEY);
          }, 100);
        }, 0);
      });
    });

    return () => {
      window.cancelAnimationFrame(firstFrameId);

      if (secondFrameId) {
        window.cancelAnimationFrame(secondFrameId);
      }

      if (timeoutId) {
        window.clearTimeout(timeoutId);
      }

      if (finalTimeoutId) {
        window.clearTimeout(finalTimeoutId);
      }
    };
  }, [location.key, location.state, visibleArticles.length]);

  const handleShowMore = () => {
    if (!hasMoreArticles) {
      return;
    }

    const nextPage = currentPage + 1;
    const currentScrollY = window.scrollY;

    /*
     * Додатково записуємо позицію в sessionStorage.
     * Це запасний варіант, якщо компонент перемонтується.
     */
    sessionStorage.setItem(BLOG_SCROLL_KEY, String(currentScrollY));

    navigate(`/blog/page/${nextPage}`, {
      state: {
        preserveBlogScroll: true,
        scrollY: currentScrollY,
      },
      preventScrollReset: true,
    });
  };

  const getArticleId = (article) => {
    return article?.uid || article?.id || "";
  };

  const renderArticleImage = (article) => {
    const articleId = getArticleId(article);

    const image = (
      <img
        src={article.photo}
        className={css.smallImgBlog}
        alt={article.zag || "Стаття блогу"}
        loading="lazy"
      />
    );

    if (article.check && article.linkto) {
      return (
        <a
          href={article.linkto}
          target="_blank"
          rel="noopener noreferrer"
          className={css.articleImageLink}
        >
          {image}
        </a>
      );
    }

    return (
      <Link to={`/blog/${articleId}`} className={css.articleImageLink}>
        {image}
      </Link>
    );
  };

  const renderArticleTitle = (article, className) => {
    const articleId = getArticleId(article);

    if (article.check && article.linkto) {
      return (
        <a
          href={article.linkto}
          target="_blank"
          rel="noopener noreferrer"
          className={className}
        >
          {article.zag}
        </a>
      );
    }

    return (
      <Link to={`/blog/${articleId}`} className={className}>
        {article.zag}
      </Link>
    );
  };

  if (!sortedBlogData.length) {
    return null;
  }

  return (
    <div className={css.bigVideoWrap}>
      <div className={css.bigVideoWrapSmall}>
        {/* {featuredArticle && (
          <div className={css.bigWrap}>
            <img
              className={css.bigImgBlog}
              src={featuredArticle.photo}
              alt={featuredArticle.zag || "Остання стаття блогу"}
            />

            <div className={css.someTextWrap}>
              {renderArticleTitle(featuredArticle, css.videoViewvH1)}

              {featuredArticle.chortDesc && (
                <p className={css.bigVideoP}>{featuredArticle.chortDesc}</p>
              )}
            </div>
          </div>
        )} */}

        <div className={css.smallVideoWrap}>
          <div className={css.smallvidelListWrap}>
            {visibleArticles.map((article, index) => (
              <article
                key={getArticleId(article) || `blog-article-${index}`}
                className={css.smalVideoPro}
              >
                <div className={css.imgWrapBorder}>
                  {renderArticleImage(article)}
                </div>

                {renderArticleTitle(article, css.videoName)}

                {article.chortDesc && (
                  <p className={css.videoNameDesc}>{article.chortDesc}</p>
                )}
              </article>
            ))}
          </div>
        </div>

        {hasMoreArticles && (
          <button
            type="button"
            className={css.mareVideo}
            onClick={handleShowMore}
          >
            Більше статей
          </button>
        )}
      </div>
    </div>
  );
}
